export const APP_ID = '2359591e743ea0e9';
export const REGION = 'eu';
export const AUTH_KEY = '27b341d68b27ffe4b109a8d845c2f5cc8ec62b4c';
export const WEB_APP_HOME = 'https://cometchat.pages.dev/';
export const WEB_APP_DYNAMIC_LINK = 'https://cometchat.page.link/?link=https://cometchat.pages.dev/__ID__&apn=com.reactnativecallingandroid';
export const WIDGET_ID = '70470a88-7f9e-4786-9dec-af41c3e6de11';
